<style scoped lang="scss">
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: center;
  flex-wrap:wrap;
  overflow: auto;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/img/产品及服务/基因调控/基因编辑/banner.png" class="img-fluid">-->
<!--      <div class="info">-->

<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>ASO/反义寡核苷酸</h1>
      <h2 class="mt10">ASO/Antisense Oligonucleotides</h2>
      <div class="a"><span></span></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc" style="margin-bottom: 20px;">ASOs 是由 12~25 个核苷酸的单链 DNA 或 RNA类似物构成的小片段，其进入细胞后在核糖核酸酶H1的作用下通过碱基互补配对原则与其互补的靶向mRNA结合，来抑制靶基因的表达。</p>
        <div class="gene_img con" style="text-align: center; margin-left: auto;margin-right: auto;"><img title="ASO反义寡核苷酸" alt="ASO反义寡核苷酸" src="@/assets/img/产品及服务/基因调控/基因干扰/shRNA4.jpg"  style="margin-top: 30px;"></div>
        <div class="gene_img cons" style="text-align: center; margin-left: auto;margin-right: auto;"><img src="@/assets/img/产品及服务/基因调控/基因干扰/shRNA4.jpg"  style="margin-top: 30px;"></div>
        <p style="line-height: 2">备注：常见调节基因表达的反义机制。(A-E)反义寡核苷酸杂交后通过两种不同的机制调节基因表达：(1)酶促RNA降解和(2)占位机制。酶促RNA降解包括(A)类DNA反义寡核苷酸，其通过RNA酶H1触发互补RNA的切割和(B)siRNA介导的通过Ago2-RISC通路减少互补RNA,和其他机制，如核酶降解。占位机制利用反义寡核苷酸与靶RNA碱基配对使得RNA不发生降解。这些作用包括但不限于: (C)用非DNA样反义寡核苷酸调节剪接，以抑制或增强剪接位点的利用;(D)用非DNA样反义寡核苷酸调节mRNA翻译，以通过空间阻断(stericblocking)抑制翻译或通过与翻译抑制元件结合激活翻译;(E)通过与miRNA碱基配对抑制miRNA功能或通过与结合有miRNA绑定位点的mRNA的位点实现消除特定miRNA效用的作用</p>
      </div>
      <div class="container">
        <div class="c-title">服务类型<small>Service type</small></div>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            :data="tableData">
            <el-table-column
              prop="method1"
              label="类型">
            </el-table-column>
            <el-table-column
              prop="method2"
              label="含量">
            </el-table-column>
            <!-- <el-table-column
              prop="method3"
              label="价格(元)">
            </el-table-column> -->
            <el-table-column
              prop="method4"
              label="备注">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/gr_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists1 effect-lists" style="display: flex!important; justify-content: center!important;">
            <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/gr_${item.img}${currentService===index ? '' : ''}.png`" style="width: 50px;height: 55px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      tableData:[
        {
          method1:'PS-ASO',
          method2:'2 OD',
          // method3:'400',
          method4:'可用于细胞实验。'
        },
        {
          method1:'OMe-ASO',
          method2:'2 OD',
          // method3:'500',
          method4:'可用于细胞实验,动物实验。'
        },
        {
          method1:'LNA-ASO',
          method2:'2 OD',
          // method3:'800',
          method4:'可用于细胞实验,动物实验。'
        },
        {
          method1:'FAM-PS阴性对照',
          method2:'2 OD',
          // method3:'400',
          method4:'-'
        },
        {
          method1:'FAM-OMe阴性对照',
          method2:'2 OD',
          // method3:'500',
          method4:'-'
        },
        {
          method1:'FAM-LNA阴性对照',
          method2:'2 OD',
          // method3:'800',
          method4:'-'
        }
      ],
      page: 0,
      total: 0,
      currentService:-1,
      types1: [
        {name: 'shRNA慢病毒质粒构建', img: '1', ref: '/products/shRNA_lentiviral'},
        {name: 'shRNA文库构建', img: '2', ref: '/products/shRNA_library_construction'},
      ],
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/ASO_antisense.vue